export const TABS_JUDICIAL_HEARINGS = ['Заседания по конференции'];
